import { useCallback } from 'react';
import toast from '@/config/react-toast'
type Props = {
  trimValue: true | false | 'left' | 'right';
  toastConfig?: {
    message: string;
    type?: 'error' | 'success';
  };
  onChange?: (event: FocusEvent) => void;
}

const useTrim = ({ trimValue, toastConfig, onChange }: Props) => {
  const handleOnBlur = useCallback((event: FocusEvent) => {
    if (!trimValue) {
      return;
    }
    const value = (event.target as HTMLInputElement).value;
    
    let isValueManipulated = false;
    let trimmedValue = value;

    switch (trimValue) {
    case 'left':
      trimmedValue = value.trimStart();
      break;
    case 'right':
      trimmedValue = value.trimEnd();
      break;
    case true:
      trimmedValue = value.trim();
      break;
    }

    if (trimmedValue !== value) {
      (event.target as HTMLInputElement).value = trimmedValue;
      isValueManipulated = true;
    }
    
    if (isValueManipulated) {
      if (toastConfig && toastConfig.message) {
        const toastType: 'error' | 'success' = toastConfig.type || 'error';
        toast(toastConfig.message, { type: toastType });
      }
      if (onChange) {
        const syntheticOnChangeEvent = Object.assign(event, {
          type: 'change',
        }) as unknown as FocusEvent;

        onChange(syntheticOnChangeEvent);
      }
    }
  }, [toastConfig, onChange, trimValue]);
  
  return { handleOnBlur };
};

export default useTrim;